import { classNames } from 'libs/react';
import { Case } from 'components/util/Case';
import { React } from 'libs/react';
import { DealItemPricingTableHeader } from './dealItemPanelGroupListItem/DealItemPricingTableHeader';
import { PackageListItem } from './dealItemPanelGroupListItem/DealPackageListItem';
import { ProposedPackageListItem } from './dealItemPanelGroupListItem/DealProposedPackageListItem';
import { Item } from './dealItemPanelGroupListItem/Item';
import { OptionListItem } from './dealItemPanelGroupListItem/DealOptionListItem';
import { ProposedOptionsListItem } from './dealItemPanelGroupListItem/DealProposedOptionListItem';
import './DealItemPanelGroupContent.scss';
/**
 * @component DealItemPanelGroupContent
 * @since 1.0.0
 */
export function DealItemPanelGroupContent(props) {
    const { style, item, type, discountRep, editable, hideSKU, isDeal, itemsGrouped, pricingDisplay, pricingParametersDisplay, quantityType, showIncludedOptions, onChangeProposedItem, hideTableHeader, onQuoteRemove } = Object.assign({ style: 'normal', editable: true }, props);
    const className = classNames('deal-item-panel-group-content', 'deal-item-panel-group-content--' + style, props.className);
    return (React.createElement(React.Fragment, null,
        React.createElement(Case, { is: type == 'item' },
            React.createElement(Item, { className: className, item: item, discountRep: discountRep, editable: editable, pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, onChangeProposedItem: onChangeProposedItem, hideTableHeader: hideTableHeader, onQuoteRemove: onQuoteRemove })),
        React.createElement(Case, { is: type == 'package' },
            React.createElement(PackageList, { className: className, item: item, discountRep: discountRep, data: item.packages, editable: editable, pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, quantityType: quantityType })),
        React.createElement(Case, { is: type == 'option' },
            React.createElement(OptionList, { className: className, item: item, data: item.options, discountRep: discountRep, editable: editable, showIncludedOptions: showIncludedOptions, pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, itemsGrouped: itemsGrouped, quantityType: quantityType })),
        React.createElement(Case, { is: type == 'optionProposed' },
            React.createElement(ProposedOptionsList, { className: className, item: item, data: item.options, editable: editable, discountRep: discountRep, isDeal: isDeal, pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, quantityType: quantityType, itemsGrouped: itemsGrouped })),
        React.createElement(Case, { is: type == 'packageProposed' },
            React.createElement(ProposedPackageList, { className: className, item: item, data: item.packages, editable: editable, discountRep: discountRep, isDeal: isDeal, pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, quantityType: quantityType }))));
}
/**
 * @component PackageList
 * @since 1.0.0
 * @hidden
 */
function PackageList(props) {
    const { item, data, editable, hideSKU, className, discountRep, pricingDisplay, pricingParametersDisplay, quantityType } = props;
    if (data == null) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DealItemPricingTableHeader, { pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, quantityType: quantityType, className: className, editable: editable, isPackage: true }),
        data.map((data) => (React.createElement(PackageListItem, { key: data.id, className: className, item: item, data: data, editable: editable, discountRep: discountRep, quantityType: quantityType, pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU })))));
}
/**
 * @component ProposedPackageList
 * @since 1.0.0
 * @hidden
 */
function ProposedPackageList(props) {
    const { item, data, editable, hideSKU, isDeal, className, pricingDisplay, pricingParametersDisplay, quantityType, discountRep } = props;
    if (data == null) {
        return null;
    }
    const recommendedPackages = data.filter((dealItemConfiguration) => dealItemConfiguration.proposed);
    return (React.createElement(React.Fragment, null,
        React.createElement(DealItemPricingTableHeader, { pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, quantityType: quantityType, className: className, editable: editable, isPackage: true }),
        recommendedPackages
            .sort((a, b) => {
            var _a, _b;
            if (((_a = a.item) === null || _a === void 0 ? void 0 : _a.sku) && ((_b = b.item) === null || _b === void 0 ? void 0 : _b.sku)) {
                return a.item.sku.localeCompare(b.item.sku);
            }
            return 1;
        })
            .map((recommendedPackage) => (React.createElement(ProposedPackageListItem, { discountRep: discountRep, key: recommendedPackage.id, className: className, item: item, data: recommendedPackage, editable: editable, isDeal: isDeal, quantityType: quantityType, pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU })))));
}
/**
 * @component OptionList
 * @since 1.0.0
 * @hidden
 */
function OptionList(props) {
    const { item, data, discountRep, editable, hideSKU, itemsGrouped, showIncludedOptions, className, pricingDisplay, pricingParametersDisplay, quantityType } = props;
    if (data == null) {
        return null;
    }
    let filteredData = data;
    if (!showIncludedOptions && !editable) {
        filteredData = data.filter((data) => {
            var _a, _b, _c;
            return (_a = item.item.options) === null || _a === void 0 ? void 0 : _a.filter((option) => !option.locked).map((option) => option.item.id).includes((_c = (_b = data === null || data === void 0 ? void 0 : data.item) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '');
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DealItemPricingTableHeader, { pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, itemsGrouped: itemsGrouped, quantityType: quantityType, className: className, editable: editable, isOption: true }),
        filteredData.map((data, index) => (React.createElement(OptionListItem, { key: data.id || `option-${index}`, className: className, item: item, data: data, discountRep: discountRep, quantityType: quantityType, editable: editable, pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, itemsGrouped: itemsGrouped })))));
}
/**
 * @component ProposedOptionsList
 * @since 1.0.0
 * @hidden
 */
function ProposedOptionsList(props) {
    const { item, data, editable, hideSKU, isDeal, className, pricingDisplay, pricingParametersDisplay, discountRep, quantityType, itemsGrouped } = props;
    if (data == null) {
        return null;
    }
    const recommendedOptions = data.filter((dealItemConfiguration) => dealItemConfiguration.proposed);
    return (React.createElement(React.Fragment, null,
        React.createElement(DealItemPricingTableHeader, { pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, itemsGrouped: itemsGrouped, quantityType: quantityType, className: className, editable: editable, isOption: true }),
        recommendedOptions.map((recommendedOption, index) => (React.createElement(ProposedOptionsListItem, { discountRep: discountRep, key: recommendedOption.id || `proposed-option-${index}`, className: className, item: item, data: recommendedOption, editable: editable, isDeal: isDeal, quantityType: quantityType, pricingDisplay: pricingDisplay, pricingParametersDisplay: pricingParametersDisplay, hideSKU: hideSKU, itemsGrouped: itemsGrouped })))));
}
